/**  This method is used to validate that an Iban is correct. The second conditional validates an Iban as correct if
 it fails only the country specific validation(checksum) whose error code is 6 and equates to `WrongAccountBankBranchChecksum` error
This will make the FE validation to be consistent with the BE validation.
npm package source Code: https://github.com/Simplify/ibantools/blob/master/src/ibantools.ts#L91-L94
 **/
import { validateIBAN } from 'ibantools'

const ValidateIban = (iban: string): boolean => {
  const trimmedIban = iban.replace(/\s/g, '')
  const ibanValidations = validateIBAN(trimmedIban)

  const WRONG_ACCOUNT_BANK_BRANCH_CHECKSUM_CODE = 6

  const hasOnlyBankChecksumError = (errorCodes: number[]) =>
    errorCodes.length === 1 && errorCodes.includes(WRONG_ACCOUNT_BANK_BRANCH_CHECKSUM_CODE)

  return ibanValidations.valid || hasOnlyBankChecksumError(ibanValidations.errorCodes)
}

export default ValidateIban
